module.exports = __webpack_public_path__ + "img/bracelet_int.89614985.jpg";